/**
* 高さ揃えのコンストラクタ
* @constructor
*/
module.exports = EqHeight = function(){};

/**
* initialize
*/
EqHeight.prototype.init = function(el){
  this.element = $(el);
  this.group = this.element.attr('data-eqHeight-cls');
  this.groupArray = this.group.split(',');
  this.resize();
  this.event();
};

/**
* event
*/
EqHeight.prototype.event = function(){
  this.checkDevice();
  if(this.device === 'sp'){
    this.removeHeight(this.groupArray);
  }else{
    this.removeHeight(this.groupArray);
    this.setHeight(this.groupArray);
  }
};

/**
* setHeight
*/
EqHeight.prototype.setHeight = function(arr){
  for(var i = 0; i < arr.length; i++){
    var $item = $('.' + arr[i]);
    var h = [];
    $item.each(function(){
      h.push($(this).outerHeight());      
    });
    var max = Math.max.apply(null, h);
    $item.each(function(){
      $(this).css('min-height', max);  
    });
  }
};

/**
* removeHeight
*/
EqHeight.prototype.removeHeight = function(arr){
  for(var i = 0; i < arr.length; i++){
    var $item = $('.' + arr[i]);
    for(var i = 0; i < arr.length; i++){
      var $item = $('.' + arr[i]);
      $item.removeAttr('style');
    }
  }
};

/**
* checkDevice
*/
EqHeight.prototype.checkDevice = function(){
  var w = $(window).width();
  var device = (w < 768) ? 'sp' : 'pc';
  this.device = device;
};

/**
* resize
*/
EqHeight.prototype.resize = function(){
  var self = this;

  var timer = false;
  $(window).on('resize', function(){
    if(timer !== false){
      clearTimeout(timer);
    }
    timer = setTimeout(function(){
      self.event();
    },200);
  });
};




//////////////////
// WEBPACK FOOTER
// ./js/_modules/eqHeight.js
// module id = 2
// module chunks = 0